import React from 'react';

const UnitPrice = ({variant}) => {

  if(!variant) return null;

  return (
    <div className='d-flex align-items-center mt-2 mb-3 unit-price-block'>
      <div className="flex-shrink-0 unit-price-title">
        Unit Price
      </div>
      <div className="flex-grow-1 ms-3 unit-price">
        {variant.display_price}
      </div>
    </div>
  )
}

export default UnitPrice;